/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/common-utils';
import { useStaticAssetPath } from '../StaticAssetProvider';

type StaticVideoProps = {
  /** Video Src */
  src: string;
};

const StaticVideo: React.FC<StaticVideoProps> = ({ src, ...props }) => {
  const { buildStaticAssetUrl } = useStaticAssetPath();
  return (
    // @ts-ignore I guess type doesnt exist on video
    <video src={buildStaticAssetUrl(src)} type="video/mp4" {...props}>
      Your browser does not support HTML5 video.
    </video>
  );
};

export default StaticVideo;
